export default {"src":"/_next/static/media/grid-icon.180d1dfd.svg","height":22,"width":22};